import { useState, useEffect } from 'react';
import { Box, CircularProgress, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "../api/axios";
import useAxiosFunction from "../hooks/useAxiosFunction";
import useJobAdvert from "../hooks/useJobAdvert";

import styles from '../styles/jobAdvert.module.scss';
import HeroBanner from '../components/HeroBanner';
import JobAdvertSection from '../components/JobAdvertSection';
import AttachmentList from '../components/AttachmentList';
import BackButton from '../components/BackButton';
import btnStyles from '../styles/buttons.module.scss';
export default function JobAdvert() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);
    const { id } = useParams();
    const {jobAdvert, loading: advertLoading, error: advertError} = useJobAdvert(id);
    const [response, error, loading, axiosFetch] = useAxiosFunction();

    if (!jobAdvert) {
        return (
        
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "60vh"
                        }}
                    >
        
                        <CircularProgress />
        
                    </Box>
        
                );
    }


    return (
        <div className={styles.page}>

            <HeroBanner
                title={jobAdvert.jobTitle}
                subtitle=""
            />

            <div className={styles.container}>

                <div className={styles.summaryRow}>

                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>Location:</span>
                        <span>{jobAdvert.locationName}</span>
                    </div>

                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>Salary:</span>
                        <span>{jobAdvert.salary}</span>
                    </div>

                    <div className={styles.summaryItem}>
                        <span className={styles.summaryLabel}>Closing Date:</span>
                        <span>{jobAdvert.closingDate}</span>
                    </div>

                    <div className={styles.applyButtonContainer}>
                        <Button
                            className={btnStyles.btnDesktop}
                            variant="contained"
                            size="large"
                            sx={{ textTransform: 'none' }}
                            onClick={() => navigate(`/job/${jobAdvert.id}/apply`)}
                        >
                            Apply
                        </Button>
                    </div>

                </div>

                <JobAdvertSection
                    title="Job Description"
                    content={jobAdvert.vacancy}
                />

                <JobAdvertSection
                    title="Key Responsibilities"
                    content={jobAdvert.keyResponsibilities}
                />

                <JobAdvertSection
                    title="What We're Looking For"
                    content={jobAdvert.whatWereLookingFor}
                />

                <JobAdvertSection
                    title="What We Offer"
                    content={jobAdvert.whatWeOffer}
                />
                <AttachmentList files={jobAdvert.files} axiosFetch={axiosFetch}/>

                <Box sx={{ mt: 4 }}>

                    <BackButton />

                </Box>

            </div>
            
        </div>

    );

}